import styles from "./styles.module.scss";
import { FC, Props } from "./typings";

import prettyBytes from "pretty-bytes";
import CancelIcon from "formassets/cancel.svg?react";
import AttachmentIconComponent from "../AttachmentIconComponent";
import { Tooltip } from "@mui/material";

const Filedossier: FC<Props> = ({
  file,
  handleRemove,
  index,
  actualFile,
  actualProgress,
}) => {
  return (
    <div className={styles.box}>
      <div className={styles.wrapper}>
        <AttachmentIconComponent file={file.name} />
        <div className={styles.information}>
          <div className={styles.name}>{file?.name}</div>
          <div className={styles.size}>{prettyBytes(file.size ?? 0)}</div>
        </div>
        <Tooltip title="Usuń">
          <div
            className={styles.options}
            onClick={(e) => {
              handleRemove(index);
              e.preventDefault();
              e.stopPropagation();
            }}
          >
            <CancelIcon />
          </div>
        </Tooltip>
      </div>
      {actualFile === index && !!actualProgress && (
        <div className={styles.progressBar}>
          <div
            style={{ width: `${actualProgress}%` }}
            className={styles.progress}
          ></div>
        </div>
      )}
    </div>
  );
};

export default Filedossier;
